// @ts-nocheck
import React, {
  useMemo,
  Suspense,
  useState,
  useEffect,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import MODULE_SUB_MODULE_OPERATIONS_TREE from '../../const/ModuleSubModuleOperationsTree';
import useNormalOperations from '../../Hooks/Pipeline/useNormalOperations';
import useMissingValuesImputation from '../../Hooks/EDA/useMissingValuesImputation';
import useDriftAnalysis from '../../Hooks/ModelTesting/useDriftAnalysis';
// Model Estimation ================================================================================
const ModelInitiationSC = React.lazy(
  () => import('../ModelEstimation/ModelInitiationSC')
);
const SaveAndDeployModel = React.lazy(
  () => import('../ModelEstimation/SaveAndDeployModel')
);
// Model Testing  ===================================================================================
const OngoingComparision = React.lazy(
  () =>
    import('../ModelTesting/PerformanceTesting/Operations/OngoingComparision')
);

const AUCLiftCurves = React.lazy(
  () => import('../ModelTesting/PerformanceTesting/Operations/AUCLiftCurves')
);
const ClassificationPlots = React.lazy(
  () =>
    import('../ModelTesting/PerformanceTesting/Operations/ClassificationPlots')
);

const AssumptionTesting = React.lazy(
  () => import('../ModelTesting/AssumptionTesting/Operations/AssumptionTesting')
);
const GoodnessOfFitTest = React.lazy(
  () => import('../ModelTesting/AssumptionTesting/Operations/GoodnessOfFitTest')
);

const ModelComparision = React.lazy(
  () => import('../ModelTesting/ModelComparision/Operations/ModelComparision')
);

const Scaling = React.lazy(
  () => import('../ModelTesting/Scoring-Scaling/Operations/Scaling')
);
const Scoring = React.lazy(
  () => import('../ModelTesting/Scoring-Scaling/Operations/Scoring')
);

const SensitivityAnalysis = React.lazy(
  () =>
    import('../ModelTesting/SensitivityAnalysis/Operations/SensitivityAnalysis')
);

const KFold = React.lazy(
  () => import('../ModelTesting/BackTesting/Operations/KFold')
);

const RankOrder = React.lazy(
  () => import('../ModelTesting/BackTesting/Operations/RankOrder')
);

const TsBackTesting = React.lazy(
  () => import('../ModelTesting/BackTesting/TsOperations/BackTesting')
);

const DataDrift = React.lazy(
  () => import('../ModelTesting/DriftAnalysis/Operations/DataDrift')
);

const Fairness = React.lazy(
  () => import('../ModelTesting/FairnessBiasness/Operations/fairness')
);

const Biasness = React.lazy(
  () => import('../ModelTesting/FairnessBiasness/Operations/biasness')
);

const ModelCalibirationTaskBar = React.lazy(
  () => import('../ModelTesting/ModelCalibiration/Operations/ModelCalibiration')
);
const ForeCastingOp = React.lazy(
  () => import('../ModelTesting/ForeCasting/Operations/ForeCastingOp')
);

// Model Interpretation =============================================================================

const BarPlotVisualization = React.lazy(
  () =>
    import(
      '../ModelInterpretation/DecisionTree/Operations/BarPlotVisualization'
    )
);
const DecisionTreeVisualization = React.lazy(
  () =>
    import(
      '../ModelInterpretation/DecisionTree/Operations/DecisionTreeVisualization'
    )
);

const FeatureDependence = React.lazy(
  () =>
    import(
      '../ModelInterpretation/FeatureInterpretation/Operations/FeatureDependence'
    )
);
const FeatureImportance = React.lazy(
  () =>
    import(
      '../ModelInterpretation/FeatureInterpretation/Operations/FeatureImportance'
    )
);
const RelativeContribution = React.lazy(
  () =>
    import(
      '../ModelInterpretation/FeatureInterpretation/Operations/RelativeContribution'
    )
);
const Contributions = React.lazy(
  () =>
    import(
      '../ModelInterpretation/IndividualPridiction/Operations/Contributions'
    )
);
const PartialDependencePlot = React.lazy(
  () =>
    import(
      '../ModelInterpretation/IndividualPridiction/Operations/PartialDependencePlot'
    )
);
const Prediction = React.lazy(
  () =>
    import('../ModelInterpretation/IndividualPridiction/Operations/Prediction')
);
const VifTable = React.lazy(
  () => import('../ModelInterpretation/TimeSeriesAnalysis/Operations/vif-table')
);
const CoefficientPlot = React.lazy(
  () =>
    import(
      '../ModelInterpretation/TimeSeriesAnalysis/Operations/coefficient-plot'
    )
);
const ModelSummary = React.lazy(
  () =>
    import('../ModelInterpretation/TimeSeriesAnalysis/Operations/model-summary')
);

// Data Management ==============================================================================================

const DPCombineDatasets = React.lazy(
  () => import('../DataPreparation/dp-combine-datasets')
);
const DPTranspose = React.lazy(() => import('../DataPreparation/dp-transpose'));
const DPAppendDataset = React.lazy(
  () => import('../DataPreparation/dp-append')
);

// EDA  ========================================================================================================
const PSSummarySatistics = React.lazy(
  () =>
    import(
      '../EDA/PreliminarySteps/Operations/SummarySatistics/summary-statistics'
    )
);

const PSOverallSummarySatistics = React.lazy(
  () =>
    import(
      '../EDA/PreliminarySteps/Operations/OverallSummary/overall-summary-stats'
    )
);

const BiVariateMethod = React.lazy(
  () => import('../EDA/VariableAnalysis/Operations/BiVariate/bivariate-method')
);

const MultiVariateMethod = React.lazy(
  () =>
    import(
      '../EDA/VariableAnalysis/Operations/MultiVariate/multivariate-method'
    )
);

const UniVariateMethod = React.lazy(
  () =>
    import('../EDA/VariableAnalysis/Operations/UniVariate/univariate-method')
);

const Homogeneity = React.lazy(
  () => import('../EDA/StatisticalTests/Homogeneity')
);

const NonParametric = React.lazy(
  () => import('../EDA/StatisticalTests/NonParametric')
);

const Normality = React.lazy(() => import('../EDA/StatisticalTests/Normality'));

const Parametric = React.lazy(
  () => import('../EDA/StatisticalTests/Parametric')
);

const StationaryTest = React.lazy(
  () => import('../EDA/TimeSeriesAnalysis/StationaryTest')
);

const ACFPACFPlots = React.lazy(
  () => import('../EDA/TimeSeriesAnalysis/ACFPACFPlots')
);

const GrangerCausalityTest = React.lazy(
  () => import('../EDA/TimeSeriesAnalysis/GrangerCausalityTest')
);

const CointegrationTest = React.lazy(
  () => import('../EDA/TimeSeriesAnalysis/CointegrationTest')
);

const SeasonalityTest = React.lazy(
  () => import('../EDA/TimeSeriesAnalysis/SeasonalityTest')
);

const MissingValues = React.lazy(
  () => import('../EDA/MissingValuesImputation/Operations/missing-values')
);

const OutlierDetection = React.lazy(
  () => import('../EDA/TreatingOutliers/OutlierDetection')
);
// Sampling & Segmentation  =======================================================================
const VisualizeImbalance = React.lazy(
  () => import('../Sampling/Operations/visualize-imbalance')
);

const Resampling = React.lazy(
  () => import('../Sampling/Operations/resampling')
);

const Sampling = React.lazy(() => import('../Sampling/Operations/sampling'));

const Splitting = React.lazy(() => import('../Sampling/Operations/splitting'));

const TimeSeriesAnalysis = React.lazy(
  () => import('../Sampling/Operations/time-series-analysis')
);

const Clustering = React.lazy(
  () => import('../Segmentation/Operations/Clustering')
);

const DecisionTree = React.lazy(
  () => import('../Segmentation/Operations/DecisionTree')
);

const RuleBased = React.lazy(
  () => import('../Segmentation/Operations/RuleBased')
);

// Feature Engineering =======================================================================
const CategoricalTransformation = React.lazy(
  () => import('../FeatureEngineering/CategoricalTransformation')
);

const NumericTransformation = React.lazy(
  () => import('../FeatureEngineering/NumericTransformation')
);

const TimeSeriesTransformation = React.lazy(
  () => import('../FeatureEngineering/TimeSeriesTransformation')
);
// Variable Reduction ========================================================================

const BackwardFeatureSelection = React.lazy(
  () => import('../VariableReduction/BackwardFeatureSelection')
);

const ClusteringVR = React.lazy(
  () => import('../VariableReduction/Clustering')
);

const ForwardFeatureSelection = React.lazy(
  () => import('../VariableReduction/ForwardFeatureSelection')
);

const HighCorrelation = React.lazy(
  () => import('../VariableReduction/HighCorrelation')
);

const IvValues = React.lazy(() => import('../VariableReduction/IvValues'));

const LowVariance = React.lazy(
  () => import('../VariableReduction/LowVariance')
);

const MissingValuesVR = React.lazy(
  () => import('../VariableReduction/MissingValues')
);

const PrincipalComponentAnalysis = React.lazy(
  () => import('../VariableReduction/PrincipalComponentAnalysis')
);

const RandomForest = React.lazy(
  () => import('../VariableReduction/RandomForest')
);

// const OpVariableFinalisation = React.lazy(
//   () => import('../VariableReduction/OpVariableFinalisation')
// );

const LassoFeatureSelection = React.lazy(
  () => import('../VariableReduction/LassoFeatureSelection')
);

const RidgeFeatureSelection = React.lazy(
  () => import('../VariableReduction/RidgeFeatureSelection')
);

const StepwiseFeatureSelection = React.lazy(
  () => import('../VariableReduction/StepwiseFeatureSelection')
);

// Model Deployment ===================================================================

// const BestModelSelection = React.lazy(
//   () => import('../ModelDeployment/BestModelSelection')
// );

// const DataDriftMD = React.lazy(() => import('../ModelDeployment/DataDrift'));

/**
 * @function NormalOperationRenderer
 * @description This function is used to render the normal operations
 * @param {String} moduleKey - module key of the operation to be rendered.
 * @param {String} subModuleKey - sub module key of the operation to be rendered.
 * @param {String} operationKey - operation key of the operation to be rendered.
 * @param {String} moduleObjKey - module key of the operation to be rendered.
 * @param {String} subModuleObjKey - sub module key of the operation to be rendered.
 * @param {String} operationObjKey - operation key of the operation to be rendered.
 * @param {Object} activeDataset - active dataset object details.
 * @param {Object} activeProject - active project object details.
 * @param {Array} permissions - permissions array for the user.
 * @param {Object} parameters - parameters object for the operation.
 * @param {Function} getOperaionForm - function to get the operation form.
 * @param {Function} onNormalOperationSubmit - function to submit the operation.
 * @param {Object} taskDetails - task details object.
 * @returns {JSX} - Normal operation component JSX.
 */
const NormalOperationRenderer = ({
  moduleKey,
  subModuleKey,
  operationKey,
  moduleObjKey,
  subModuleObjKey,
  operationObjKey,
  activeDataset = {},
  activeProject = {},
  permissions = [],
  parameters = {},
  getOperaionForm = () => {},
  onNormalOperationSubmit = () => {},
  taskDetails = {},
  additionalModelsFromPrevNode = [],
  additionalDatasetFromPrevNode = [],
  allWorkersList = [],
}) => {
  const {
    fetchBigDataStatus,
    targetVariables,
    datasetColumnDetails,
    datasetList,
    allModelData,
    datasetRowsWithPagination,
    fetchDatasetAllColumnDetails,
    idx,
    binningColumn,
    updatebinningID,
    fetchResamplingMethods,
    finalSubmit,
    ordinalColumn,
    // fetchVariableFinalisation,
    // sendVariableFinalisation,
    // variableFinalisation,
    fetchDatasetList,
    savedModels,
    fetchSavedModelList,
    renameModelDisplayName,
    deploySavedModel,
    deploySavedModelWithConfig,
    // fetchMEModuleTasks,
    // allMETasks,
    fetchModelsDetails,
    fetchMetricData,
  } = useNormalOperations({
    operationKey,
    activeDataset,
    moduleKey,
    subModuleKey,
    activeProject,
    moduleObjKey,
    subModuleObjKey,
    operationObjKey,
  });

  // const fetchMEModuleTaskWrapper = (hideLoaderOnRequest) => {
  //   fetchMEModuleTasks(activeProject?.project_id, hideLoaderOnRequest);
  // };
  const [missingValuesDatasetColumns, setMissingValuesDatasetColumns] =
    useState([]);
  const { fetchDatasetColumnDetails } = useMissingValuesImputation();
  const { fetchDatasetColumnDetailsWithModuleKey } = useDriftAnalysis();
  useEffect(() => {
    if (activeDataset?.id && activeProject?.project_id) {
      fetchDatasetColumnDetails(
        {
          dataset_id: activeDataset?.id,
          project_id: activeProject?.project_id,
        },
        (resdata) => {
          setMissingValuesDatasetColumns(resdata?.Columnlist);
        }
      );
    }
  }, [
    setMissingValuesDatasetColumns,
    activeDataset?.id,
    activeProject?.project_id,
  ]);
  const DefaultNoOpFound = React.useMemo(
    () => <Typography variant="body3">No operation found!</Typography>,
    []
  );
  const dataHelper = useCallback(() => {}, []);
  const dynamicOperationSwitch = (
    mKey,
    sKey,
    oKey,
    _targetVariables,
    _allModelData,
    _savedModels,
    _missingValuesDatasetColumns
  ) => {
    const OPERATIONS =
      MODULE_SUB_MODULE_OPERATIONS_TREE?.[mKey]?.subModules?.[sKey]?.operations;
    const operationObj = { key: OPERATIONS?.[oKey]?.key };

    switch (mKey) {
      case MODULE_SUB_MODULE_OPERATIONS_TREE.DM.key:
        switch (sKey) {
          case MODULE_SUB_MODULE_OPERATIONS_TREE.DM.subModules.DPA.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.DM.subModules.DPA
                .operations.CD.key:
                return (
                  <DPCombineDatasets
                    activeProject={activeProject}
                    activeDataset={activeDataset}
                    dataSets={datasetList}
                    dpCombineDatasetRequest={onNormalOperationSubmit}
                    fetchDatasetColumnDetails={
                      fetchDatasetColumnDetailsWithModuleKey
                    }
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.DM.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.DM.subModules.DPA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    parameters={parameters}
                    additionalDatasetFromPrevNode={
                      additionalDatasetFromPrevNode
                    }
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.DM.subModules.DPA
                .operations.AP.key:
                return (
                  <DPAppendDataset
                    dpAppendDataset={onNormalOperationSubmit}
                    activeDataset={activeDataset}
                    activeProject={activeProject}
                    datasets={datasetList}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.DM.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.DM.subModules.DPA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    parameters={parameters}
                    additionalDatasetFromPrevNode={
                      additionalDatasetFromPrevNode
                    }
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.DM.subModules.DPA
                .operations.TR.key:
                return (
                  <DPTranspose
                    activeProject={activeProject}
                    dpTranspose={onNormalOperationSubmit}
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.DM.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.DM.subModules.DPA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    parameters={parameters}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          default:
            return DefaultNoOpFound;
        }
      case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key:
        switch (sKey) {
          case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.PS.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.PS
                .operations.OSS.key:
                return (
                  <PSOverallSummarySatistics
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    fetchingDatasetSummaryStats={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.PS.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.PS
                .operations.SS.key:
                return (
                  <PSSummarySatistics
                    activeDataset={activeDataset}
                    datasetColumnDetails={datasetColumnDetails}
                    fetchColumnSummaryStats={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.PS.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );

              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TO.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TO
                .operations.OD.key:
                return (
                  <OutlierDetection
                    activeDataset={activeDataset}
                    activeOperation={{
                      key: MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TO
                        .operations.OD.key,
                    }}
                    datasetColumnDetails={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    getOutlierDetectionResults={onNormalOperationSubmit}
                    getOutlierTreatmentResults={onNormalOperationSubmit}
                    saveTreatmentResults={onNormalOperationSubmit}
                    idx={idx}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TO.key}`
                      ]
                    }
                    fetchTableDataResult={dataHelper}
                    downloadTableData={dataHelper}
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.MVI.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.MVI
                .operations.MVI.key:
                return (
                  <MissingValues
                    activeDataset={activeDataset}
                    datasetColumnDetails={_missingValuesDatasetColumns}
                    taskResults={{}}
                    parameters={parameters}
                    missingValuesSubmitOp={onNormalOperationSubmit}
                    missingValuesSaveOp={onNormalOperationSubmit}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.MVI.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );

              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.VA.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.VA
                .operations.UV.key:
                return (
                  <UniVariateMethod
                    activeDataset={activeDataset}
                    datasetColumnDetails={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    fetchVariableAnalysis={onNormalOperationSubmit}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.VA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.VA
                .operations.BV.key:
                return (
                  <BiVariateMethod
                    activeDataset={activeDataset}
                    datasetColumnDetails={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    fetchVariableAnalysis={onNormalOperationSubmit}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.VA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.VA
                .operations.MV.key:
                return (
                  <MultiVariateMethod
                    activeDataset={activeDataset}
                    datasetColumnDetails={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    fetchVariableAnalysis={onNormalOperationSubmit}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.VA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.STS.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.STS
                .operations.NPT.key:
                return (
                  <NonParametric
                    activeDataset={activeDataset}
                    chiSquareCol={datasetColumnDetails}
                    getChiSquareCol={fetchDatasetAllColumnDetails}
                    statsNonParametric={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.STS.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.STS
                .operations.TFN.key:
                return (
                  <Normality
                    activeDataset={activeDataset}
                    activeProject={activeProject}
                    onSubmitClick={onNormalOperationSubmit}
                    activeDatasetColumns={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.STS.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.STS
                .operations.PT.key:
                return (
                  <Parametric
                    activeDataset={activeDataset}
                    datasets={datasetList}
                    activeProject={activeProject}
                    onStatisticalPatametric={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.STS.key}`
                      ]
                    }
                    datasetColumnDetails={datasetColumnDetails}
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.STS
                .operations.HOV.key:
                return (
                  <Homogeneity
                    activeDataset={activeDataset}
                    activeProject={activeProject}
                    datasets={datasetList}
                    statsHomogeneity={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    fetchDatasetColumnDetails={fetchDatasetAllColumnDetails}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.STS.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    datasetColumnDetails={datasetColumnDetails}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA
                .operations.ST.key:
                return (
                  <StationaryTest
                    activeDataset={activeDataset}
                    activeProject={activeProject}
                    onStationaryTest={onNormalOperationSubmit}
                    activeDatasetColumns={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );

              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA
                .operations.APP.key:
                return (
                  <ACFPACFPlots
                    activeDataset={activeDataset}
                    activeProject={activeProject}
                    onACFPACFTest={onNormalOperationSubmit}
                    activeDatasetColumns={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA
                .operations.GCT.key:
                return (
                  <GrangerCausalityTest
                    activeDataset={activeDataset}
                    activeProject={activeProject}
                    onGrangerCausalityTest={onNormalOperationSubmit}
                    activeDatasetColumns={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA
                .operations.CT.key:
                return (
                  <CointegrationTest
                    activeDataset={activeDataset}
                    activeProject={activeProject}
                    onCointegrationTest={onNormalOperationSubmit}
                    activeDatasetColumns={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA
                .operations.SET.key:
                return (
                  <SeasonalityTest
                    activeDataset={activeDataset}
                    activeProject={activeProject}
                    onSeasonalityTest={onNormalOperationSubmit}
                    activeDatasetColumns={datasetColumnDetails}
                    taskResults={{}}
                    parameters={parameters}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.EDA.subModules.TSA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          default:
            return DefaultNoOpFound;
        }
      case MODULE_SUB_MODULE_OPERATIONS_TREE.FE.key:
        // not adding submodule switch case here as there is no submodule. Adding directly operation switch case.
        switch (oKey) {
          case MODULE_SUB_MODULE_OPERATIONS_TREE.FE.subModules.FE.operations.NT
            .key:
            return (
              <NumericTransformation
                activeDataset={activeDataset}
                columnData={datasetColumnDetails}
                numericTransformationRequest={onNormalOperationSubmit}
                taskResults={{}}
                parameters={parameters}
                activeProject={activeProject}
                binningColumn={binningColumn}
                biningID={
                  taskDetails?.results?.binning_id
                    ? taskDetails?.results?.binning_id
                    : 0
                }
                updatebinningID={updatebinningID}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.FE.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.FE.subModules.FE.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.FE.subModules.FE.operations.CT
            .key:
            return (
              <CategoricalTransformation
                activeDataset={activeDataset}
                columnData={datasetColumnDetails}
                taskResults={{}}
                parameters={parameters}
                activeProject={activeProject}
                binningColumn={binningColumn}
                ordinalColumn={ordinalColumn}
                categoricalTransformationRequest={onNormalOperationSubmit}
                biningID={
                  taskDetails?.results?.binning_id
                    ? taskDetails?.results?.binning_id
                    : 0
                }
                updatebinningID={updatebinningID}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.FE.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.FE.subModules.FE.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.FE.subModules.FE.operations.VT
            .key:
            return (
              <TimeSeriesTransformation
                activeDataset={activeDataset}
                columnData={datasetColumnDetails}
                taskResults={{}}
                parameters={parameters}
                activeProject={activeProject}
                binningColumn={binningColumn}
                timeSeriesTransformationRequest={onNormalOperationSubmit}
                biningID={
                  taskDetails?.results?.binning_id
                    ? taskDetails?.results?.binning_id
                    : 0
                }
                updatebinningID={updatebinningID}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.FE.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.FE.subModules.FE.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          default:
            return DefaultNoOpFound;
        }
      case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.key:
        switch (sKey) {
          case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.operations
                .VI.key:
                return (
                  <VisualizeImbalance
                    activeDataset={activeDataset}
                    columnData={datasetColumnDetails}
                    visualizeImbalance={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.operations
                .SP.key:
                return (
                  <Sampling
                    activeDataset={activeDataset}
                    columnData={datasetColumnDetails}
                    samplingResults={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.operations
                .RSP.key:
                return (
                  <Resampling
                    activeDataset={activeDataset}
                    columnData={datasetColumnDetails}
                    activeProject={activeProject}
                    resamplingResults={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    fetchResamplingMethods={fetchResamplingMethods}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.operations
                .SPL.key:
                return (
                  <Splitting
                    activeDataset={activeDataset}
                    columnData={datasetColumnDetails}
                    splittingResults={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.operations
                .SPT.key:
                return (
                  <TimeSeriesAnalysis
                    activeDataset={activeDataset}
                    columnData={datasetColumnDetails}
                    timeSeriesAnalysisResults={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );

              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SE.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SE.operations
                .CL.key:
                return (
                  <Clustering
                    activeDataset={activeDataset}
                    activeDatasetColumns={datasetColumnDetails}
                    clusterOperation={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SE.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SE.operations
                .DT.key:
                return (
                  <DecisionTree
                    activeDataset={activeDataset}
                    activeDatasetColumns={datasetColumnDetails}
                    decisionOperation={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    targetColumns={_targetVariables}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SE.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SE.operations
                .RB.key:
                return (
                  <RuleBased
                    activeDataset={activeDataset}
                    activeDatasetColumns={datasetColumnDetails}
                    ruleBasedOperation={onNormalOperationSubmit}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.SS.subModules.SE.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }

          default:
            return DefaultNoOpFound;
        }
      case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key:
        // not adding submodule switch case here as there is no submodule. Adding directly operation switch case.
        switch (oKey) {
          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.MV
            .key:
            return (
              <MissingValuesVR
                activeDataset={activeDataset}
                activeProject={activeProject}
                activeOperation={operationObj}
                columnData={datasetColumnDetails}
                taskResults={{}}
                parameters={parameters}
                missingValuesSubmit={onNormalOperationSubmit}
                finalSubmit={finalSubmit}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );

          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.PCA
            .key:
            return (
              <PrincipalComponentAnalysis
                activeDataset={activeDataset}
                activeProject={activeProject}
                datasetColumnDetails={datasetColumnDetails}
                taskResults={{}}
                targetVariables={_targetVariables || []}
                parameters={parameters}
                pcaSubmit={onNormalOperationSubmit}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );

          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.LV
            .key:
            return (
              <LowVariance
                lowVarianceSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                activeOperation={operationObj}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.HC
            .key:
            return (
              <HighCorrelation
                highCorrelationSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                columnData={datasetColumnDetails}
                activeOperation={operationObj}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.RF
            .key:
            return (
              <RandomForest
                randomForestSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                activeOperation={operationObj}
                datasetColumnDetails={datasetColumnDetails}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.CL
            .key:
            return (
              <ClusteringVR
                clusteringSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                activeOperation={operationObj}
                datasetColumnDetails={datasetColumnDetails}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.IVV
            .key:
            return (
              <IvValues
                ivValuesSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                activeOperation={operationObj}
                datasetColumnDetails={datasetColumnDetails}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.BFS
            .key:
            return (
              <BackwardFeatureSelection
                backwardFeatureSelectionSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                columnData={datasetColumnDetails}
                activeOperation={operationObj}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.FFS
            .key:
            return (
              <ForwardFeatureSelection
                forwardFeatureSelectionSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                columnData={datasetColumnDetails}
                activeOperation={operationObj}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.LFS
            .key:
            return (
              <LassoFeatureSelection
                lassoFeatureSelectionSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                columnData={datasetColumnDetails}
                activeOperation={operationObj}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );

          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.RFS
            .key:
            return (
              <RidgeFeatureSelection
                ridgeFeatureSelectionSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                columnData={datasetColumnDetails}
                activeOperation={operationObj}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.SFS
            .key:
            return (
              <StepwiseFeatureSelection
                stepwiseFeatureSelectionSubmit={onNormalOperationSubmit}
                activeDataset={activeDataset}
                activeProject={activeProject}
                columnData={datasetColumnDetails}
                activeOperation={operationObj}
                taskResults={{}}
                parameters={parameters}
                finalSubmit={finalSubmit}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
                  ]
                }
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
              />
            );
          // case MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.operations.VF
          //   .key:
          //   return (
          //     <OpVariableFinalisation
          //       variableFinalisation={variableFinalisation}
          //       fetchVariableFinalisation={fetchVariableFinalisation}
          //       activeDataset={activeDataset}
          //       sendVariableFinalisation={sendVariableFinalisation}
          //       activeOperation={operationObj}
          //       datasets={datasetList}
          //       activeProject={activeProject}
          //       updateActiveDatasetWrapper={() => {}}
          //       permission={
          //         permissions[
          //           `${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.VR.subModules.VR.key}`
          //         ]
          //       }
          //       isImportedInPipeline={true}
          //       getOperaionForm={getOperaionForm}
          //     />
          //   );
          default:
            return DefaultNoOpFound;
        }
      case MODULE_SUB_MODULE_OPERATIONS_TREE.ME.key:
        // not adding submodule switch case here as there is no submodule. Adding directly operation switch case.
        switch (oKey) {
          case MODULE_SUB_MODULE_OPERATIONS_TREE.ME.subModules.ME.operations.MI
            .key:
            return (
              <ModelInitiationSC
                isImportedInPipeline={true}
                activeDataset={activeDataset}
                activeProject={activeProject}
                targetVariables={_targetVariables || []}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.ME.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.ME.subModules.ME.key}`
                  ]
                }
                fetchDatasetColumnDetails={fetchDatasetAllColumnDetails}
                fetchDatasetList={fetchDatasetList}
                moduleName={MODULE_SUB_MODULE_OPERATIONS_TREE.ME.key}
                subModuleName={
                  MODULE_SUB_MODULE_OPERATIONS_TREE.ME.subModules.ME.key
                }
                onModelInitiationScoreCardSubmit={onNormalOperationSubmit}
                taskDetails={{}}
                parameters={parameters}
                fetchBigDataStatus={fetchBigDataStatus}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
                datasetList={datasetList}
                additionalDatasetFromPrevNode={
                  additionalDatasetFromPrevNode || []
                }
              />
            );
          case MODULE_SUB_MODULE_OPERATIONS_TREE.ME.subModules.ME.operations.SDM
            .key:
            return (
              <SaveAndDeployModel
                allModelsData={[
                  ...additionalModelsFromPrevNode,
                  ..._allModelData,
                ]}
                savedModels={_savedModels}
                getSavedModelList={() =>
                  fetchSavedModelList(
                    activeProject?.project_id,
                    [
                      'id',
                      'external_pkl',
                      'model_name',
                      'model_technique_label',
                      'label',
                      'archive',
                      'status',
                      'train_table',
                      'model_technique',
                    ].join()
                  )
                }
                renameModelDisplayName={renameModelDisplayName}
                tableNames={datasetList}
                deploySavedModel={deploySavedModel}
                fetchDatasetList={fetchDatasetList}
                activeProject={activeProject}
                activeDataset={activeDataset}
                parameters={parameters}
                handleChange={dataHelper}
                fetchAsyncResult={dataHelper}
                fetchModuleTaskWrapper={dataHelper}
                setReadStatusWrapper={dataHelper}
                updateActiveOperationWrapper={dataHelper}
                targetVariables={_targetVariables || []}
                deploySavedModelWithConfig={deploySavedModelWithConfig}
                permission={
                  permissions[
                    `${MODULE_SUB_MODULE_OPERATIONS_TREE.ME.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.ME.subModules.ME.key}`
                  ]
                }
                taskDetails={{}}
                isImportedInPipeline={true}
                getOperaionForm={getOperaionForm}
                allWorkersList={allWorkersList}
                additionalModelsFromPrevNode={additionalModelsFromPrevNode}
              />
            );
          default:
        }
        break;
      case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key:
        switch (sKey) {
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.PT.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.PT.operations
                .OO.key:
                return (
                  <OngoingComparision
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onOngoingComparisionSubmit={onNormalOperationSubmit}
                    onTsOngoingComparisionSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.PT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    fetchMetricData={fetchMetricData}
                    additionalDatasetFromPrevNode={
                      additionalDatasetFromPrevNode
                    }
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.PT.operations
                .CP.key:
                return (
                  <ClassificationPlots
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onClassificationPlotSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.PT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.PT.operations
                .AUC.key:
                return (
                  <AUCLiftCurves
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onAucListCurvesSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.PT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.AT.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.AT.operations
                .GFT.key:
                return (
                  <GoodnessOfFitTest
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    datasetColumnDetails={datasetColumnDetails}
                    allModelData={
                      [...additionalModelsFromPrevNode, ..._allModelData] || []
                    }
                    onAssumptionTestingAndGofTestSubmit={
                      onNormalOperationSubmit
                    }
                    onAssumptionTestingSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.AT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.AT.operations
                .AT.key:
                return (
                  <AssumptionTesting
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    datasetColumnDetails={datasetColumnDetails}
                    allModelData={
                      [...additionalModelsFromPrevNode, ..._allModelData] || []
                    }
                    onAssumptionTestingAndGofTestSubmit={
                      onNormalOperationSubmit
                    }
                    onAssumptionTestingSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.AT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.MC.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.MC.operations
                .MC.key:
                return (
                  <ModelComparision
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={
                      [...additionalModelsFromPrevNode, ..._allModelData] || []
                    }
                    onModelComparisionSubmit={onNormalOperationSubmit}
                    onTsModelComparisionSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.MC.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    fetchMetricData={fetchMetricData}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.SS.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.SS.operations
                .SC.key:
                return (
                  <Scoring
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onScoringSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.SS.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.SS.operations
                .SCA.key:
                return (
                  <Scaling
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onScalingSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.SS.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.BT.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.BT.operations
                .RO.key:
                return (
                  <RankOrder
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onRankOrderSubmit={onNormalOperationSubmit}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.BT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    additionalDatasetFromPrevNode={
                      additionalDatasetFromPrevNode
                    }
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.BT.operations
                .KF.key:
                return (
                  <KFold
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onKFoldSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.BT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.BT.operations
                .BT.key:
                return (
                  <TsBackTesting
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    targetVariables={_targetVariables || []}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onBackTestingSubmit={onNormalOperationSubmit}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    datasetRows={datasetRowsWithPagination}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.BT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.SA.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.SA.operations
                .SA.key:
                return (
                  <SensitivityAnalysis
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    targetVariables={_targetVariables || []}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onSensitivityAnalysisSubmit={onNormalOperationSubmit}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    // fetchTableDataResult={fetchTableDataResult}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.SA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.FA.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.FA.operations
                .BA.key:
                return (
                  <Biasness
                    activeDataset={activeDataset}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={
                      [...additionalModelsFromPrevNode, ..._allModelData] || []
                    }
                    targetVariables={_targetVariables || []}
                    fetchBiasnessStatsRequest={onNormalOperationSubmit}
                    datasetColumnDetails={datasetColumnDetails}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.FA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.FA.operations
                .FA.key:
                return (
                  <Fairness
                    activeDataset={activeDataset}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={
                      [...additionalModelsFromPrevNode, ..._allModelData] || []
                    }
                    targetVariables={_targetVariables || []}
                    fetchFairnessStatsRequest={onNormalOperationSubmit}
                    datasetColumnDetails={datasetColumnDetails}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.FA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.DA.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.DA.operations
                .DD.key:
                return (
                  <DataDrift
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    submitDataDrift={onNormalOperationSubmit}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.DA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    additionalDatasetFromPrevNode={
                      additionalDatasetFromPrevNode
                    }
                    fetchDatasetColumnDetails={fetchDatasetAllColumnDetails}
                    fetchDatasetColumnDetailsWithModuleKey={
                      fetchDatasetColumnDetailsWithModuleKey
                    }
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.MR.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.MR.operations
                .MC.key:
                return (
                  <ModelCalibirationTaskBar
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onModelCalibrationSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.MR.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    fetchModelsDetails={fetchModelsDetails}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.FC.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.FC.operations
                .FC.key:
                return (
                  <ForeCastingOp
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    targetVariables={_targetVariables || []}
                    onForeCastingSubmit={onNormalOperationSubmit}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MT.subModules.FC.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                    additionalDatasetFromPrevNode={
                      additionalDatasetFromPrevNode
                    }
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          default:
            return DefaultNoOpFound;
        }
      case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key:
        switch (sKey) {
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.FI.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.FI.operations
                .FM.key:
                return (
                  <FeatureImportance
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onFeatureImportanceSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.FI.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.FI.operations
                .FD.key:
                return (
                  <FeatureDependence
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onFeatureDependenceSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.FI.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );

              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.FI.operations
                .RC.key:
                return (
                  <RelativeContribution
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={
                      [...additionalModelsFromPrevNode, ..._allModelData] || []
                    }
                    onRelativeContributionSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.FI.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );

              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.IP.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.IP.operations
                .PD.key:
                return (
                  <Prediction
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={
                      [...additionalModelsFromPrevNode, ..._allModelData] || []
                    }
                    targetVariables={_targetVariables || []}
                    onPredictionSubmit={onNormalOperationSubmit}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.IP.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.IP.operations
                .CT.key:
                return (
                  <Contributions
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    targetVariables={_targetVariables || []}
                    onContributionSubmit={onNormalOperationSubmit}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.IP.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.IP.operations
                .PDP.key:
                return (
                  <PartialDependencePlot
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    targetVariables={_targetVariables || []}
                    onPartialDependenceSubmit={onNormalOperationSubmit}
                    featureList={[]}
                    datasetColumnDetails={datasetColumnDetails}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.IP.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.DT.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.DT.operations
                .BPV.key:
                return (
                  <BarPlotVisualization
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={
                      [...additionalModelsFromPrevNode, ..._allModelData] || []
                    }
                    onDecisionTreeSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.DT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.DT.operations
                .DTV.key:
                return (
                  <DecisionTreeVisualization
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    onDecisionTreeSubmit={onNormalOperationSubmit}
                    targetVariables={_targetVariables || []}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.DT.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.TSA.key:
            switch (oKey) {
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.TSA
                .operations.VIF.key:
                return (
                  <VifTable
                    activeDataset={activeDataset}
                    datasetList={datasetList}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={
                      [...additionalModelsFromPrevNode, ..._allModelData] || []
                    }
                    targetVariables={_targetVariables || []}
                    fetchVitTableRequest={onNormalOperationSubmit}
                    activeProject={activeProject}
                    datasetColumnDetails={datasetColumnDetails}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.TSA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.TSA
                .operations.CT.key:
                return (
                  <CoefficientPlot
                    activeDataset={activeDataset}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    fetchCoefficientTableRequest={onNormalOperationSubmit}
                    datasetColumnDetails={datasetColumnDetails}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.TSA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              case MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.TSA
                .operations.MS.key:
                return (
                  <ModelSummary
                    activeDataset={activeDataset}
                    taskResults={{}}
                    parameters={parameters}
                    allModelData={[
                      ...additionalModelsFromPrevNode,
                      ..._allModelData,
                    ]}
                    fetchModelSummaryRequest={onNormalOperationSubmit}
                    datasetColumnDetails={datasetColumnDetails}
                    activeProject={activeProject}
                    permission={
                      permissions[
                        `${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MI.subModules.TSA.key}`
                      ]
                    }
                    isImportedInPipeline={true}
                    getOperaionForm={getOperaionForm}
                    allWorkersList={allWorkersList}
                  />
                );
              default:
                return DefaultNoOpFound;
            }
          default:
            return DefaultNoOpFound;
        }
      // case MODULE_SUB_MODULE_OPERATIONS_TREE.MD.key:
      //   switch (sKey) {
      //     case MODULE_SUB_MODULE_OPERATIONS_TREE.MD.subModules.MD.key:
      //       switch (oKey) {
      //         case MODULE_SUB_MODULE_OPERATIONS_TREE.MD.subModules.MD.operations
      //           .DD.key:
      //           return (
      //             <DataDriftMD
      //               activeDataset={activeDataset}
      //               activeProject={activeProject}
      //               columnData={datasetColumnDetails}
      //               datasetList={datasetList}
      //               parameters={parameters}
      //               submitDataDrift={onNormalOperationSubmit}
      //               taskResults={{}}
      //               permission={
      //                 permissions[
      //                   `${MODULE_SUB_MODULE_OPERATIONS_TREE.MD.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MD.subModules.MD.key}`
      //                 ]
      //               }
      //               isImportedInPipeline={true}
      //               getOperaionForm={getOperaionForm}
      //             />
      //           );
      //         case MODULE_SUB_MODULE_OPERATIONS_TREE.MD.subModules.MD.operations
      //           .BMS.key:
      //           return (
      //             <BestModelSelection
      //               activeDataset={activeDataset}
      //               activeProject={activeProject}
      //               datasetList={datasetList}
      //               taskResults={{}}
      //               allModelData={
      //                 [...additionalModelsFromPrevNode, ..._allModelData] || []
      //               }
      //               allMETasks={allMETasks}
      //               parameters={parameters}
      //               fetchMEModuleTaskWrapper={fetchMEModuleTaskWrapper}
      //               bestModelSelectionSubmit={onNormalOperationSubmit}
      //               permission={
      //                 permissions[
      //                   `${MODULE_SUB_MODULE_OPERATIONS_TREE.MD.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.MD.subModules.MD.key}`
      //                 ]
      //               }
      //               isImportedInPipeline={true}
      //               getOperaionForm={getOperaionForm}
      //             />
      //           );
      //         default:
      //           return DefaultNoOpFound;
      //       }
      //     default:
      //       return DefaultNoOpFound;
      //   }
      default:
        return DefaultNoOpFound;
    }
  };

  const memoizedOperationValue = useMemo(
    () =>
      dynamicOperationSwitch(
        moduleKey,
        subModuleKey,
        operationKey,
        targetVariables,
        allModelData,
        savedModels,
        missingValuesDatasetColumns
      ),
    [
      moduleKey,
      subModuleKey,
      operationKey,
      targetVariables,
      allModelData,
      activeDataset,
      datasetList,
      datasetColumnDetails,
      savedModels,
      missingValuesDatasetColumns,
    ]
  );

  return (
    <>
      <Suspense
        fallback={
          <Typography variant="body3">
            Unable to render form at the moment.
          </Typography>
        }
      >
        {memoizedOperationValue}
        <div />
      </Suspense>
    </>
  );
};

NormalOperationRenderer.defaultProps = {
  additionalDatasetFromPrevNode: [],
};

NormalOperationRenderer.propTypes = {
  moduleKey: PropTypes.string.isRequired,
  operationKey: PropTypes.string.isRequired,
  subModuleKey: PropTypes.string.isRequired,
  moduleObjKey: PropTypes.string.isRequired,
  subModuleObjKey: PropTypes.string.isRequired,
  operationObjKey: PropTypes.string.isRequired,
  activeDataset: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOfType([PropTypes.object]),
  ]).isRequired,
  activeProject: PropTypes.oneOfType([PropTypes.object]).isRequired,
  permissions: PropTypes.string.isRequired,
  parameters: PropTypes.oneOfType([PropTypes.object]).isRequired,
  getOperaionForm: PropTypes.func.isRequired,
  onNormalOperationSubmit: PropTypes.func.isRequired,
  taskDetails: PropTypes.oneOfType([PropTypes.object]).isRequired,
  additionalModelsFromPrevNode: PropTypes.oneOfType([PropTypes.array])
    .isRequired,
  additionalDatasetFromPrevNode: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object])
  ),
  allWorkersList: PropTypes.oneOfType([PropTypes.array]).isRequired,
};
export default NormalOperationRenderer;
